(function () {
	function pruneMissingLinks() {
		const nav = document.querySelector(".pdp-tab-buttons");
		if (!nav) return;

		nav.querySelectorAll("[data-pdp-tab-target]").forEach((link) => {
			const targetId = link.getAttribute("data-pdp-tab-target");
			if (!targetId || !document.getElementById(targetId)) {
				link.remove();
			}
		});

		if (!nav.querySelector("[data-pdp-tab-target]")) {
			nav.remove();
		}
	}

	function getFocusTarget(target) {
		if (target.matches('[role="tab"]')) {
			const panelId = target.getAttribute("aria-controls");
			const panel = panelId ? document.getElementById(panelId) : null;
			return panel || target;
		}

		if (target.matches("details")) {
			return target.querySelector(".disclosure__panel") || target;
		}

		return target;
	}

	function activateTarget(target) {
		if (target.matches('[role="tab"]')) {
			target.click();
			return;
		}

		if (target.matches("details") && !target.open) {
			const summary = target.querySelector("summary");
			if (summary) summary.click();
		}
	}

	function getScrollOffset() {
		const rootStyles = getComputedStyle(document.documentElement);
		const headerHeight = parseFloat(rootStyles.getPropertyValue("--header-height")) || 0;
		return headerHeight > 0 ? headerHeight + 20 : 130;
	}

	function scrollToTarget(element) {
		if (!element) return;

		const elementPosition = element.getBoundingClientRect().top + window.scrollY;
		const offsetPosition = elementPosition - getScrollOffset();

		window.scrollTo({ top: offsetPosition, behavior: "smooth" });
	}

	function handleClick(evt) {
		const link = evt.target.closest("[data-pdp-tab-target]");
		if (!link) return;

		const targetId = link.getAttribute("data-pdp-tab-target");
		const target = targetId ? document.getElementById(targetId) : null;
		if (!target) return;

		evt.preventDefault();

		activateTarget(target);
		const focusTarget = getFocusTarget(target);
		const scrollTarget = target.matches('[role="tab"]') ? focusTarget : target;

		scrollToTarget(scrollTarget);

		if (focusTarget && typeof focusTarget.focus === "function") {
			focusTarget.focus({ preventScroll: true });
		}
	}

	pruneMissingLinks();
	document.addEventListener("click", handleClick);
})();
